import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'doNotAcceptLegalAidForAllCases',
        'acceptLegalAidForAllCases',
        'acceptLegalAidOnlyFor',
        'errorContainer',
        'allLawyerSpecialismsContainer',
    ];

    static values = {
        legalAidOption: String,
    };

    legalAidOption = null;

    openModal(data) {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });

        this.legalAidOption = this.legalAidOptionValue;
        this.addEventListenerForLegalAidOptions();

        if (this.acceptLegalAidOnlyForTarget.checked) {
            this.changeLegalAidOnlyForOptions(false);
        } else {
            this.changeLegalAidOnlyForOptions(true);
        }
    }

    save() {
        let selectedOptions = null;

        if (
            !this.doNotAcceptLegalAidForAllCasesTarget.checked
            && !this.acceptLegalAidForAllCasesTarget.checked
            && !this.acceptLegalAidOnlyForTarget.checked
        ) {
            this.errorContainerTarget.innerHTML = translations['profile.Please select an option'];
            return;
        } else if (this.acceptLegalAidOnlyForTarget.checked) {
            selectedOptions = this.getLegalAidSelectedOptions();

            if (selectedOptions.length < 1) {
                this.errorContainerTarget.innerHTML = translations['profile.Please select at least 1 area of law'];
                return;
            } else {
                this.errorContainerTarget.innerHTML = '';
            }
        }

        showPreloader();

        $.ajax({
            url: routes['app_profile_legalaidupdate'],
            data: {
                legalAid: this.legalAidOption,
                selectedOptions: selectedOptions,
            },
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'legal-aid | Success',
                            'label': GA_EVENT_LABEL,
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                    addAlert('danger', translations['profile.An unknown error occurred.']);
                }
            },
            error: function() {
                hidePreloader();
                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        });
    }

    checkboxChange(event) {
        if (event.target === this.doNotAcceptLegalAidForAllCasesTarget) {
            this.acceptLegalAidForAllCasesTarget.checked = false;
            this.acceptLegalAidOnlyForTarget.checked = false;
            this.legalAidOption = 'no_legal_aid';

            this.changeLegalAidOnlyForOptions(true);
        }

        if (event.target === this.acceptLegalAidForAllCasesTarget) {
            this.doNotAcceptLegalAidForAllCasesTarget.checked = false;
            this.acceptLegalAidOnlyForTarget.checked = false;
            this.legalAidOption = 'all_legal_aid';

            this.changeLegalAidOnlyForOptions(true);
        }

        if (event.target === this.acceptLegalAidOnlyForTarget) {
            this.doNotAcceptLegalAidForAllCasesTarget.checked = false;
            this.acceptLegalAidForAllCasesTarget.checked = false;
            this.legalAidOption = 'selected_legal_aid';

            $(this.allLawyerSpecialismsContainerTarget)
                .find('.accept-legal-aid-only-for')
                .each((index, element) => {
                    this.changeLegalAidOnlyForOptions(false);
                });
        }

        if (translations['profile.Please select an option'] === this.errorContainerTarget.innerHTML) {
            this.errorContainerTarget.innerHTML = '';
        }

        if (event.target === this.acceptLegalAidOnlyForTarget) {
            this.element.querySelectorAll('input[id^="accept-legal-aid-only-for-"]').forEach((element) => {
                element.disabled = false;
            });
        } else {
            this.element.querySelectorAll('input[id^="accept-legal-aid-only-for-"]').forEach((element) => {
                element.checked = false;
                element.disabled = true;
            });
        }
    }

    changeLegalAidOnlyForOptions(disableFields) {
        $(this.allLawyerSpecialismsContainerTarget)
            .find('.accept-legal-aid-only-for')
            .each((index, element) => {
                if (disableFields) {
                    element.parentElement.classList.add('disabled');
                    element.disabled = 'disabled';
                    return;
                }

                element.parentElement.classList.remove('disabled');
                element.disabled = '';
            });
    }

    getLegalAidSelectedOptions() {
        let selectedOptions = [];

        $(this.allLawyerSpecialismsContainerTarget)
            .find('.accept-legal-aid-only-for')
            .each((index, element) => {
                if (element.checked) {
                    selectedOptions.push(element.value);
                }
            });

        return selectedOptions;
    }

    addEventListenerForLegalAidOptions() {
        $(this.allLawyerSpecialismsContainerTarget)
            .find('.accept-legal-aid-only-for')
            .each((index, element) => {
                $(element).on('change', (event) => {
                    if (
                        translations['profile.Please select at least 1 area of law'] === this.errorContainerTarget.innerHTML
                        && element.checked
                    ) {
                        this.errorContainerTarget.innerHTML = '';
                    }
                });
            });
    }
}
